u.Carousel = class extends u.BaseElement {
    /**
     * 
     */    
    createdCallback() {
        /**
         * 
         */
        super.createdCallback();
        this._index = 0;
        this._container = this.firstElementChild;
        this._startIndex = parseInt(this.getAttribute('start-index')) || 0;
        this._numOfChildren = this._container.childElementCount;
    }

    $moveTo(query) {
        /**
         *
         */
        
        // this code calculates the total number of items per page based on the client width of an item and the container
        const itemsPerPage = Math.floor(this._container.clientWidth / this._container.firstElementChild.clientWidth);

        if (query.startsWith('+')) {
            this._index += parseInt(query.substr(1));
        } else if (query.startsWith('-')) {
            this._index -= parseInt(query.substr(1));
        } else {
            this._index = parseInt(query) - this._startIndex;
        }
        this._index %= (this._numOfChildren / itemsPerPage);
        if (this._index < 0) {
            this._index += (this._numOfChildren / itemsPerPage);
        }
        const percent = this._index * -100;
        this._container.style.transform = `translateX(${percent}%)`;
        this.$onChange();

        var event = new CustomEvent('move', {
            detail: {
                index: this._index + this._startIndex
            }
        });

        this.dispatchEvent(event);
        return this._index;
    }

    $onChange() {
        /**
         * Extendable function
         */
    }
};

u.Carousel.register('u-carousel');
